module.exports = __webpack_public_path__ + "img/cw_yf_feiYongBaoXiao.fc3bd432.svg";